class ValidationError {
  propertyName: string;
  errorMessage: string;

  constructor(data: { propertyName: string, errorMessage: string }) {
    this.propertyName = data.propertyName;
    this.errorMessage = data.errorMessage;
  }
}

class ValidationResponse {
  public isValid: boolean;
  public errors: ValidationError[];

  // TODO: this seemed to work with strings but idk, now needs object, verify it works
  constructor(data: { isValid: boolean, errors: ValidationError[] }) {
    this.isValid = data.isValid;
    this.errors = data.errors.map(error => new ValidationError(error));
  }
}

export {ValidationResponse};